<template>

  <div class="d-flex gap15 justify-center">

    <div class="report-option">

      <div class="report-option-head">
        <div class="time-label">
          <i class="material-icons-outlined">access_time</i> 7 mins
        </div>
        <i class="material-icons-outlined main-icon">bolt</i>
      </div>

      <div class="report-option-title-row">
        <div class="report-option-title">1-click silo</div>
        <div v-if="isWhiteGloveUser" class="report-option-content-label new-content">New content</div>
      </div>

      <div  class="report-option-desc">
        Have POP do keyword research for you and save time. Just enter your keyword and let POP build your silo instantly.
      </div>

      <v-btn
        class="report-option-btn"
        outlined
        large
        color="gray12Color"
        @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy/one-click-silo/create`)"
      >
        <span class="text-none">Create silo</span> <i class="material-icons-outlined">arrow_forward</i>
      </v-btn>

    </div>

    <div class="report-option">

      <div class="report-option-head">
        <div class="time-label">
          <i class="material-icons-outlined">access_time</i> 45 mins
        </div>
        <i class="material-icons-outlined main-icon">build</i>
      </div>

      <div class="report-option-title-row">
        <div class="report-option-title">Custom silo</div>
        <div v-if="isWhiteGloveUser" class="report-option-content-label new-content">New content</div>
      </div>

      <div  class="report-option-desc">
        Perfect if you have time to do your own keyword research. Apply filters, view clusters and build your silo your way.
      </div>

      <v-btn
        class="report-option-btn"
        outlined
        large
        color="gray12Color"
        @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy/custom-silo/create`)"
      >
        <span class="text-none">Create silo</span> <i class="material-icons-outlined">arrow_forward</i>
      </v-btn>

    </div>

    <div class="report-option" v-if="isWhiteGloveUser || isSpecialAdminUser">

      <div class="report-option-head">
        <div class="time-label">
          <i class="material-icons-outlined">access_time</i> 20 mins
        </div>
        <i class="material-icons-outlined main-icon">troubleshoot</i>
      </div>

      <div class="report-option-title-row">
        <div class="report-option-title">GSC silo</div>
        <div class="report-option-content-label existing-content">Existing content</div>
      </div>

      <div  class="report-option-desc">
        Use your Search Console data to uncover live pages with high traffic potential and help you plan your silo around them.
      </div>

      <v-btn
        class="report-option-btn"
        outlined
        large
        color="gray12Color"
        @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy/existing-content`)"
      >
        <span class="text-none">Create silo</span> <i class="material-icons-outlined">arrow_forward</i>
      </v-btn>

    </div>
    
  </div>

</template>

<script>
export default {
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    
  },
  data () {
    return {
      selectedLocation: null,
      selectedLanguage: null,
    }
  },
  computed: {
    isSpecialAdminUser () {
      return this.$store.getters.isSpecialAdminUser
    },
  },
  watch: {

  },
  methods: {
    
  },
  mounted () {
    if (this.$route.query.initLanguage) {
      this.selectedLanguage = this.$route.query.initLanguage
    } else {
      this.selectedLanguage = this.campaign.languageCode
    }

    if (this.$route.query.initLocation) {
      this.selectedLocation = this.$route.query.initLocation ? Number(this.$route.query.initLocation) : ''
    } else {
      this.selectedLocation = this.campaign.locationCode ? Number(this.campaign.locationCode) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.report-option {
  flex: 1;
  padding: 16px;
  border-radius: 5px;
  background-color: var(--v-whiteColor-base);
  border: 1px solid var(--v-gray12Color-base);
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 396px;

  .report-option-head {
    background-color: #E9F0FF;
    padding: 20px;
    text-align: center;
    border-radius: 4px;

    position: relative;

    .time-label {
      position: absolute;
      top: 8px;
      right: 8px;
      padding: 2px 4px;
      border-radius: 3px;
      background: #fff;
      font-size: 0.8rem;
      color: #666666;

      display: flex;
      align-items: center;
      gap: 4px;

      i {
        font-size: 0.8rem;
        color: #666666;
      }
    }

    .main-icon {
      color: #1E85FF;
      font-size: 5rem;
    }
  }

  .report-option-title-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 14px;
    .report-option-title {
      flex: 1;
      color: var(--v-mainColor3-base);
      font-size: 1.3rem;
      font-weight: 600;
    }
    .report-option-content-label {
      color: var(--v-mainColor3-base);
      font-size: 0.85rem;
      padding: 2px 6px;
      border-radius: 3px;

      &.new-content {
        color: #008A35;
        background-color: #E8FAF1;
      }
      &.existing-content {
        color: #D36300;
        background-color: #FAF2E8;
      }
    }
  }

  .report-option-desc {
    flex: 1;
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .report-option-btn {
    .v-btn__content {
      span {
        font-size: 1rem;
      }
      
      i {
        font-size: 1rem;
        margin-top: 2px;
      }

      span, i {
        color: var(--v-mainColor3-base);
      }
    }

    &:hover, &:active {
      border-color: var(--v-profileAnchorColor-base);
      background-color: var(--v-profileAnchorColor-base);
      .v-btn__content {
        span {
          font-weight: bold;
        }
        span, i {
          color: #fff;
        }
      }
    }
  }
}
</style>